import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { indonesiaGeographicGroups } from '../data/mock';

export const IndonesiaJourneysPage = () => {
  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />

      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-secondary)',
        padding: '120px 0 80px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Indonesia Journeys
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Discover Indonesia's extraordinary diversity — from volcanic coffee trails to ancient temples, luxury beach retreats to pristine marine expeditions. Curated with insider access and authentic cultural immersion.
          </p>
        </div>
      </section>

      {/* Geographic Groups Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: '48px' }}>Explore Indonesia by Region</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {indonesiaGeographicGroups.map((group) => (
              <Link
                key={group.id}
                to={`/indonesia-journeys/${group.id}`}
                style={{
                  textDecoration: 'none',
                  display: 'block',
                  borderRadius: 0,
                  overflow: 'hidden',
                  background: 'var(--bg-primary)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                className="region-card"
              >
                <div style={{
                  width: '100%',
                  height: '240px',
                  overflow: 'hidden'
                }}>
                  <img
                    src={group.image}
                    alt={group.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    className="region-card-image"
                  />
                </div>
                <div style={{ padding: '24px' }}>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                    {group.name}
                  </h3>
                  <p className="body-regular" style={{ 
                    color: 'var(--text-secondary)', 
                    marginBottom: '16px',
                    lineHeight: 1.6,
                    minHeight: '72px'
                  }}>
                    {group.description}
                  </p>
                  <span style={{
                    color: 'var(--gold)',
                    fontSize: '14px',
                    letterSpacing: '0.5px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}>
                    Explore region <ArrowRight size={16} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .region-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 16px rgba(0,0,0,0.1);
        }
        .region-card:hover .region-card-image {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
};
